export default __webpack_public_path__ + "static/media/logo_final.ad342bcf.png";